import MainCard from '@/components/MainCard';
import React, { useState, useRef, useEffect } from "react";
import { Table, Input, Button, Space, Typography } from "antd";
import { SearchOutlined } from "@ant-design/icons";
// import Highlighter from "react-highlight-words";
import "./Graph_new.css";
import { LeftOutlined } from "@ant-design/icons"; // Import Back Arrow Icon
import { useNavigate } from "react-router-dom";
import { get_Machine_Available } from '@/utils/api';
import { useLocation } from "../../../../node_modules/react-router-dom/dist/index";
import Icons from '@/components/third-party/Icons';
import { useTheme } from '@/App';
import { useTranslation } from "react-i18next";
import { formatTime } from '@/utils/datetime';

const { Title } = Typography;
const Graph_new = () => {
  const { t } = useTranslation();
  const { isDark } = useTheme();
  const textColor = isDark ? '#ffffff' : '#1f2937';

  const location = useLocation();
  const machine_id = location.state?.machine_id;

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const [globalSearchText, setGlobalSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [processData, setProcessData] = useState(null); // Data from API
  const navigate = useNavigate();

  const equipmentData = [
    { key: "1", name: "Tablet Press Machine", type: "Compression" },
    { key: "2", name: "Capsule Filling Machine", type: "Encapsulation" },
    { key: "3", name: "Granulator", type: "Mixing" },
    { key: "4", name: "Coating Pan", type: "Coating" },
    { key: "5", name: "Blister Packing Machine", type: "Packaging" },
    { key: "6", name: "Bottle Filling Machine", type: "Liquid Filling" },
    { key: "7", name: "Cartoning Machine", type: "Packaging" },
    { key: "8", name: "Labeling Machine", type: "Packaging" },
    { key: "9", name: "Dryer", type: "Drying" },
    { key: "10", name: "Autoclave", type: "Sterilization" },
  ];

  // Function to shuffle array (Fisher-Yates shuffle algorithm)
  const shuffleArray = (array) => {
    let currentIndex = array.length,
      randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex !== 0) {
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ];
    }

    return array;
  };

  // Sample data structure based on the image
  const initialBatchData = [ // Renamed to initialBatchData
    {
      key: "1",
      date: "06/06/17",
      product: "Clopidogrel tab USP 75mg",
      batchNo: "JKS 4936",
      activity: "Operations",
      timeFrom: "08:50",
      timeTo: "14:38",
      idleTime: "01:12",
      type: "Type A",
      equipmentName: equipmentData[0].name,
    },
    {
      key: "2",
      date: "06/06/17",
      product: "Clopidogrel tab USP 75mg",
      batchNo: "JKS 4936",
      activity: "Operations",
      timeFrom: "15:50",
      timeTo: "17:05",
      idleTime: "00:45",
      type: "Type A",
      equipmentName: equipmentData[1].name,
    },
    {
      key: "3",
      date: "06/06/17",
      product: "Clopidogrel tab USP 75mg",
      batchNo: "JKS 4937",
      activity: "Operations",
      timeFrom: "17:51",
      timeTo: "06:43",
      idleTime: "02:30",
      type: "Type B",
      equipmentName: equipmentData[2].name,
    },
    {
      key: "4",
      date: "07/06/17",
      product: "Amoxicillin Capsules",
      batchNo: "LMN 7890",
      activity: "Manufacturing",
      timeFrom: "09:00",
      timeTo: "16:00",
      idleTime: "01:00",
      type: "Type C",
      equipmentName: equipmentData[3].name,
    },
    {
      key: "5",
      date: "07/06/17",
      product: "Paracetamol Syrup",
      batchNo: "PQR 1234",
      activity: "Packaging",
      timeFrom: "10:30",
      timeTo: "15:45",
      idleTime: "00:30",
      type: "Type A",
      equipmentName: equipmentData[4].name,
    },
    {
      key: "6",
      date: "08/06/17",
      product: "Vitamin C Tablets",
      batchNo: "STU 5678",
      activity: "Quality Check",
      timeFrom: "11:00",
      timeTo: "13:00",
      idleTime: "00:15",
      type: "Type B",
      equipmentName: equipmentData[5].name,
    },
    {
      key: "7",
      date: "08/06/17",
      product: "Ibuprofen Tablets",
      batchNo: "VWX 9012",
      activity: "Operations",
      timeFrom: "14:00",
      timeTo: "20:00",
      idleTime: "02:00",
      type: "Type C",
      equipmentName: equipmentData[6].name,
    },
    {
      key: "8",
      date: "09/06/17",
      product: "Aspirin Tablets",
      batchNo: "YZA 3456",
      activity: "Manufacturing",
      timeFrom: "08:00",
      timeTo: "12:00",
      idleTime: "00:45",
      type: "Type A",
      equipmentName: equipmentData[7].name,
    },
    {
      key: "9",
      date: "09/06/17",
      product: "Multivitamin Capsules",
      batchNo: "BCD 6789",
      activity: "Packaging",
      timeFrom: "13:00",
      timeTo: "17:00",
      idleTime: "01:30",
      type: "Type B",
      equipmentName: equipmentData[8].name,
    },
    {
      key: "10",
      date: "10/06/17",
      product: "Zinc Tablets",
      batchNo: "EFG 0123",
      activity: "Quality Check",
      timeFrom: "09:30",
      timeTo: "11:30",
      idleTime: "00:20",
      type: "Type C",
      equipmentName: equipmentData[9].name,
    },
  ];
  const [batchData, setBatchData] = useState(() => {
    // Shuffle and slice initial data on initial load
    const shuffledData = shuffleArray([...initialBatchData]); // Shuffle a copy
    return shuffledData.slice(0, 5); // Take first 5
  });


  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 2, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        // <Highlighter
        //   highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        //   searchWords={[searchText]}
        //   autoEscape
        //   textToHighlight={text ? text.toString() : ""}
        // />
        text
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Equipment Name",
      dataIndex: "machine_name", // Updated dataIndex to 'machine_name'
      key: "machine_name",
      align: "left",
      width: "25%",
      className: "product-column",
      ...getColumnSearchProps("machine_name"),
      onCell: () => {
        return {
          style: {
            backgroundColor: "#e6f7ff",
            fontWeight: "500",
            padding: "12px 16px",
          },
        };
      },
    },
    {
      title: "Product Name",
      dataIndex: "product_name", // Updated dataIndex to 'product_name'
      key: "product_name",
      align: "left",
      width: "20%",
      ...getColumnSearchProps("product_name"),
    },
    {
      title: "Batch No./Lot No",
      dataIndex: "batch_number", // Updated dataIndex to 'batch_number'
      key: "batch_number",
      align: "center",
      width: "15%",
      ...getColumnSearchProps("batch_number"),
    },
    {
      title: "Time",
      children: [
        {
          title: "From",
          dataIndex: "machine_start_time", // Updated dataIndex to 'machine_start_time'
          key: "machine_start_time",
          align: "center",
          width: "15%",
          ...getColumnSearchProps("machine_start_time"),
          render: (text) => formatTime(text), // Format time
        },
        {
          title: "To",
          dataIndex: "machine_end_time", // Updated dataIndex to 'machine_end_time'
          key: "machine_end_time",
          align: "center",
          width: "15%",
          ...getColumnSearchProps("machine_end_time"),
          render: (text) => formatTime(text), // Format time
        },
      ],
    },
    {
      title: "Machine Availability",
      dataIndex: "machine_availability",
      key: "machine_availability",
      align: "center",
      width: "15%",
      render: (availability) => (availability ? "Available" : "Not Available"), // Display "Available" or "Not Available"
    },
  ];

  // Global search filter
  const globalSearch = (data) => {
    if (!globalSearchText) return data;
    return data.filter((record) =>
      Object.values(record).some(
        (value) =>
          value &&
          value
            .toString()
            .toLowerCase()
            .includes(globalSearchText.toLowerCase())
      )
    );
  };


  useEffect(() => {
    const fetchData = async () => {
        setLoading(true);
        setError(null);
        try {
          get_Machine_Available({machine_id:machine_id}, (response) => {
                console.log("Full API Response:", response.data);
                setProcessData(response.data.data); // Access the 'data' array
            });
        } catch (e) {
            setError(e);
            console.error("Fetching data failed", e);
        } finally {
            setLoading(false);
        }
    };

    fetchData();
}, [machine_id]);

  return (
    <MainCard
      title={
        <div className="flex items-center gap-2">
          <Icons.Activity className="w-7 h-7 text-blue-600" />
          <Title level={4} style={{ color: textColor, margin: 0, padding: 0 }}>
            {processData && processData.length > 0 ? (
              <>
                {t('Equipment Availability')} - {processData[0].machine_name}
              </>
            ) : (
              t('Equipment Availability')
            )}
          </Title>
        </div>
      }
    >
      <div
        style={{
          marginTop: -7,
          display: "flex",
          justifyContent: "flex-end",
          gap: 10,
        }}
      >
        <Input.Search
          placeholder="Global Search"
          onChange={(e) => setGlobalSearchText(e.target.value)}
          style={{ width: 200 }}
          allowClear
        />
        <Button
          icon={<LeftOutlined />}
          style={{ marginLeft: 10 }}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </div>

      {processData && processData.length > 0 ? (
        <Table
          columns={columns}
          dataSource={globalSearch(processData)} // Use processData for dataSource
          bordered
          size="small"
          pagination={false}
          className="equipment-table"
          loading={loading} // Add loading indicator
        />
      ) : !loading ? ( // Conditionally render message when no data and not loading
        <div style={{ textAlign: "center", padding: "20px" }}>
          No Machine Available
        </div>
      ) : null}
    </MainCard>
  );
};

export default Graph_new;
